import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import { CSSTransition } from "react-transition-group";
import useClickElsewhere from "./useClickElsewhere";
import filterOptionTransitions from "./filterOptionTransitions.module.scss";
import classes from "venuescanner-js/react/components/Srp/components/Filters/filterBar.module.scss";
import { RefShape } from "venuescanner-js/react/shapes";
import isSSR from "venuescanner-js/services/isSSR";

const FilterPopup = ({
  isActive,
  onClose,
  title,
  className = "",
  children,
  excludedRefs = [],
  ...props
}) => {
  const ref = useRef(null);
  // console.log('render FilterPopup')
  useClickElsewhere([ref, ...excludedRefs], onClose, isActive);

  return (
    <CSSTransition
      in={isActive}
      classNames={filterOptionTransitions}
      timeout={300}
      key="content"
      unmountOnExit
    >
      <div className={classes.contentWrapper} {...props}>
        <div ref={ref} className={cl(classes.content, className)}>
          <header>
            <strong>{title}</strong>
            <button type="button" onClick={onClose}>
              &times;
            </button>
          </header>
          {children}
        </div>
      </div>
    </CSSTransition>
  );
};
FilterPopup.propTypes = {
  isActive: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  excludedRefs: PropTypes.arrayOf(RefShape),
};

export default FilterPopup;
